'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'cherries';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e0ec';
var svgPathData = ['M172.1 209.5c7.2 4.6 13.9 10 19.9 16.1 10.2-10.4 22.4-18.8 36-24.6L292.8 49.8 407.3 218.5c15.7 24.7 24.7 54.1 24.7 85.5 0 70.8-34.3 131.9-86.8 172.4 12.5 2.4 25.5 3.6 38.8 3.6 106 0 192-78.8 192-176 0-61.9-50.1-112-112-112-5.4 0-10.7 .4-15.9 1.1L317 0 261.9 0 172.1 209.5z', 'M384 304c0 97.2-86 176-192 176S0 401.2 0 304c0-61.9 50.1-112 112-112 31.3 0 59.7 12.9 80 33.6 20.3-20.7 48.7-33.6 80-33.6 61.9 0 112 50.1 112 112z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCherries = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;